import promisedSocket from '../../../websocket';
import * as sub from '../../../modules/bet-ticker/actions/subscription';
import api from 'src/api';
import { fromJS } from 'immutable';

const unsubscribeBet = ( dispatch, id, key ) => {
    setTimeout( () => dispatch( sub.unsubscribe( id, key ) ), 60 * 60 * 1000 );
};

function handleChannelSubscription(dispatch, channel, key) {
    const handleIncoming = (d, s) => {
        s.emit('subscribe', channel);
        s.removeAllListeners(channel);

        s.on(channel, data => {
            const msg = JSON.parse(data);
            const { header: { id }, body: { bet } } = msg;

            dispatch( sub.addBetTickerBet( id, bet, key ) );

            // Auto remove bets from bet-ticker after a period of time
            unsubscribeBet( dispatch, id, key );
        });
    };

    promisedSocket
        .then(socket => {
            handleIncoming(dispatch, socket);
            socket.on('auth', () => handleIncoming(dispatch, socket));
        });
}

export function subscribe(dispatch, action) {
    handleChannelSubscription(dispatch, 'staff:BetPlace', 'accepted');
}

export function subscribeSettled(dispatch, action) {
    handleChannelSubscription(dispatch, 'staff:BetSettled', 'settled');
}

export function subscribeRejected(dispatch, action) {
    handleChannelSubscription(dispatch, 'staff:RejectedBet', 'rejected');
}

// TODO: Remove this modifier when Kafka bet model will be extended with ip field
export function addAndModifyBetTickerBet(dispatch, { id, bet, key }) {
    api
        .get(`/bets/${bet.account.id}/${bet.id}`, null, { cache: true })
        .then(data => {
            const newBet = fromJS(Object.assign(bet, { ip: data.ip }));
    
            return dispatch(sub.finish(id, bet, key));
        },
        errors => {
            const newBet = fromJS(Object.assign(bet, { ip: '' }));

            return dispatch(sub.finish(id, bet, key));
        });
}
